enum ComplianceStatus {
  noFlagsFound = 'no_flags_found',
  notApplicable = 'not_applicable',
}

export default ComplianceStatus;
